import React from "react";
import { useInView } from "framer-motion";
import { useNoMotion } from "@/lib/a11yPrefs";

// Counts 0 → `to` (easeOut) once it scrolls into view. prefix/suffix keep units.
export default function CountUp({ to, duration = 1.6, prefix = "", suffix = "" }) {
  const ref = React.useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  // ברינדור הסטטי בזמן build (בלי window) מציגים את המספר הסופי, כדי שב-HTML
  // שסורקים קוראים לא יופיע "0". בדפדפן הספירה מתחילה מ-0 כרגיל.
  const [val, setVal] = React.useState(typeof window === "undefined" ? to : 0);

  const noMotion = useNoMotion();

  React.useEffect(() => {
    if (!inView) return;
    // בעצירת אנימציות מציגים מיד את המספר הסופי במקום לספור אליו
    if (noMotion) { setVal(to); return; }
    let raf;
    let start = null;
    const tick = (t) => {
      if (start === null) start = t;
      const p = Math.min((t - start) / (duration * 1000), 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(eased * to));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, to, duration, noMotion]);

  return <span ref={ref}>{prefix}{val}{suffix}</span>;
}
